export const main = {
  heroSection: {
    title: 'Scale up the quality GameScale',
    button: '서비스 둘러보기',
    link: 'https://developers.gamescale.io/ko/services',
  },
}
